<ion-fab *ngIf="devOverlay$ | async" horizontal="start" vertical="bottom" slot="fixed">
  <ion-fab-button color="secondary" size="small">
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </ion-fab-button>
  <ion-fab-list *ngIf="theme$ | async as theme" side="end">
    <ion-fab-button [color]="theme === 'light' ? 'primary' : 'medium'" click-stop-propagation (click)="setTheme(theme === 'dark' ? 'light' : 'dark')">
      <ion-icon name="contrast-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-button [color]="(demoProxy$ | async) ? 'primary' : 'medium'" click-stop-propagation (click)="toggleDemoProxy()">
      <ion-icon name="desktop-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-button [color]="(debug$ | async) ? 'primary' : 'medium'" click-stop-propagation (click)="toggleDebug()">
      <ion-icon name="code-slash-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-button [color]="(prefill$ | async) ? 'primary' : 'medium'" click-stop-propagation (click)="togglePrefill()">
      <ion-icon name="color-fill-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-button
      *ngLet="language$ | async as lang"
      [color]="lang === 'fr' ? 'primary' : 'medium'"
      click-stop-propagation
      (click)="setLanguage(lang === 'fr' ? 'en' : 'fr')"
    >
      <ion-icon name="language-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-button color="medium" click-stop-propagation (click)="openLogsModal()">
      <ion-icon name="reader-outline"></ion-icon>
    </ion-fab-button>

    <ion-badge *ngIf="newLogsCount$ | async as newLogsCount" color="danger" mode="ios" style="left: 92%; top: 0px; z-index: 3; position: absolute">{{
      newLogsCount
    }}</ion-badge>
  </ion-fab-list>
</ion-fab>
